import { Injectable } from '@angular/core';
import { ApiService } from './api.service';
import { Observable } from 'rxjs/Rx';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import { ContextService } from './context.service';


@Injectable()
export class HomeService {

  constructor( private apiService: ApiService, private contextService: ContextService ) {}

  getAllEditeurs(): Observable<[string]> {
    let context = this.contextService.getContext();
    return this.apiService.get('/editeur/' + context)
           .map(data => data.editeur);
  }

  getAllNiveaux(): Observable<[string]> {
    return this.apiService.get('/niveauScolaire')
           .map(data => data.niveauScolaire);
  }

  getAllDisciplines(): Observable<[string]> {
    return this.apiService.get('/discipline')
           .map(data => data.discipline);
  }

   getDisciplinesByNiveau(idNiveau): Observable<[string]> {
    return this.apiService.get('/discipline/niveau/'+idNiveau)
           .map(data => data.discipline);
  }

  getAllClasses(): Observable<[string]> {
    return this.apiService.get('/classeDiplome')
           .map(data => {
            return data.classeDiplome.sort((a, b) => {
              if (a.ordreAffichage < b.ordreAffichage) return -1;
              else if (a.ordreAffichage > b.ordreAffichage) return 1;
              else return 0;
            });

           });
  }

  getClassesByNiveau(idNiveau): Observable<[string]> {
    return this.apiService.get('/classeDiplome/'+idNiveau)
           .map(data => {
            return data.sort((a, b) => {
              if (a.ordreAffichage < b.ordreAffichage) return -1;
              else if (a.ordreAffichage > b.ordreAffichage) return 1;
              else return 0;
            });

           });
  }

  getAllTypes(): Observable<[string]> {
    return this.apiService.get('/typeArticle')
            .map(data => data.typeArticle);
  }

  getCmsDatas(): Observable<[string]> {
    return this.apiService.getwp('/')
            .map(data => data);
  }


  getAllActualites(): Observable<[string]> {
    return this.apiService.getwp('/')
            .map(data => data.actu);
  }

  getAllNouveautes(): Observable<[string]> {
    return this.apiService.getwp('/')
            .map(data => data.nouv);
  }

  getPage(slug: string): Observable<any> {
    return this.apiService.getwp(`/${slug}`)
        .map(data => data);
  }

 

}



// WEBPACK FOOTER //
// ./src/app/shared/services/home.service.ts